<template>
    <!-- Карточка пользователя в спике -->
    <div :class="`list_item px-4 py-4 list-item-component disc-card-${item.uid}`">
        <div class="vx-row">
            <div class="vx-col w-full flex sm:items-center sm:flex-row flex-col">
                <div class="lg:flex w-full lg:justify-between lg:items-center">
                    <vs-row>
                        <vs-col vs-w="4" vs-xs="12" v-if="item.discipline">
                            <strong>
                                {{item.discipline.name}}
                            </strong>
                        </vs-col>
                        <vs-col vs-lg="8" vs-xs="12">
                            <vs-row v-if="item.storage_final_grades">
                                <vs-col vs-w="2">
                                    <div class="list_val">
                                        <div class="text-sm text-gray-500">{{$t('number_passes')}}</div>
                                        <div>{{item.missed_count}}</div>
                                    </div>
                                </vs-col>
                                <vs-col vs-w="2">
                                    <div class="list_val">
                                        <div class="text-sm text-gray-500">{{$t('sr_to')}}</div>
                                        <div>{{item.storage_final_grades.average_current_score}}</div>
                                    </div>
                                </vs-col>
                                <vs-col vs-w="2">
                                    <div class="list_val">
                                        <div class="text-sm text-gray-500">{{$t('RK')}} 1</div>
                                        <div>{{item.storage_final_grades.control_first}}</div>
                                    </div>
                                </vs-col>
                                <vs-col vs-w="2">
                                    <div class="list_val">
                                        <div class="text-sm text-gray-500">{{$t('RK')}} 2</div>
                                        <div>{{item.storage_final_grades.control_second}}</div>
                                    </div>
                                </vs-col>
                                <vs-col vs-w="2">
                                    <div class="list_val">
                                        <div class="text-sm text-gray-500">{{$t('RD')}}</div>
                                        <div>{{item.storage_final_grades.tolerance_rating}}</div>
                                    </div>
                                </vs-col>
                                <vs-col vs-w="1">
                                    <div class="list_val">
                                        <div class="text-sm text-gray-500">{{$t('Exam').slice(0,1)}}</div>
                                        <div>{{item.storage_final_grades.exam}}</div>
                                    </div>
                                </vs-col>
                                <vs-col vs-w="1">
                                    <div class="list_val">
                                        <div class="text-sm text-gray-500">{{$t('io')}}</div>
                                        <div>{{item.storage_final_grades.final_grade}}</div>
                                    </div>
                                </vs-col>
                            </vs-row>
                        </vs-col>

                        <vs-col vs-w="12" class="mt-2" v-if="item.acad_period">
                            <span>
                                {{ item.acad_period.name }}
                            </span>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed:{
        RD(){
            if (this.item){
                var ob =this.item.rd.toString().slice(0,5)
                return ob
            }
        }
    }

}
</script>

<style lang="scss">
.list_item{
    position: relative;
    .con-vs-loading{
        background: transparent;
    }
}
</style>

<style lang="scss" scoped>
@media only screen and (max-width: 900px) {
    .list_val{
        margin-top: 10px;
    }
}
</style>
